import { render, staticRenderFns } from "./Pos_day_end_report.vue?vue&type=template&id=20ca6f58&"
import script from "./Pos_day_end_report.vue?vue&type=script&lang=js&"
export * from "./Pos_day_end_report.vue?vue&type=script&lang=js&"
import style0 from "./Pos_day_end_report.vue?vue&type=style&index=0&id=20ca6f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports